import * as React from 'react';
import { ExcelTool } from './excel_tool';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { WTable } from '../table/WTable';

interface WExcelViewerProps extends React.ClassAttributes<any> {
    data: string;
}

interface WExcelViewerState {
    workbook: any;
}

export class WExcelViewer extends React.Component<WExcelViewerProps, WExcelViewerState>  {
    constructor(props: any) {
        super(props);
        this.state = {
            workbook: null
        };
    }

    private excel = new ExcelTool();

    componentDidMount() {
        const workbook = this.excel.getWorkbook(this.props.data, 'base64');
        if (workbook && workbook.Sheets && Array.isArray(workbook.SheetNames) && workbook.SheetNames.length > 0) {
            console.log(workbook);
            this.setState({ workbook });
        }
    }

    generateColumnsNew(sheetData: Array<any>) {
        const columns: Array<any> = [];
        let titleRow: Array<string> = null;
        const lenArr = sheetData.map((row: Array<string>) => {
            if (!titleRow && row.length > 0) {
                titleRow = row;
            }
            return row.length;
        });
        const maxLen = Math.max(...lenArr);
        for (let i = 0; i < maxLen; i++) {
            if (!titleRow[i]) {
                titleRow[i] = '';
            }
            columns.push({
                accessor: i + '',
                Header: titleRow[i],
                id: 'spalte_' + i
            });
        }
        console.log(maxLen, columns);
        return columns;
    }

    generateColumns(sheetData: Array<any>) {
        // console.log(sheetData);
        const columns = new Array<any>();
        if (sheetData.length > 0) {
            const maxCol = sheetData.reduce((total, value) => value.length > total.length ? value : total);
            for (let i = 0; i < maxCol.length; i++) {
                const acc = i;
                const item: any = { accessor: acc + '', Header: 'Spalte ' + (i + 1), id: 'spalte' + i };
                columns.push(item);
            }
        }
        return columns;
    }

    render() {
        const tab: Array<JSX.Element> = [];
        const tabPanel: Array<JSX.Element> = [];
        if (this.state.workbook) {
            const sheetDataAll = this.excel.getJSONAll(this.state.workbook, true);

            this.state.workbook.SheetNames.map((sheet: string, idx: number) => {
                const sheetData = sheetDataAll[sheet];
                const columns = this.generateColumns(sheetData);

                tab.push(<Tab key={idx}>{sheet}</Tab>);
                tabPanel.push(
                    <TabPanel key={idx}>
                        <WTable
                            entity={sheet}
                            columns={columns}
                            onAction={() => { }}
                            rawData={sheetData}
                            data={sheetData}
                            showPagination={true}
                            pageSize={5}
                        />
                    </TabPanel>
                );
            });
        }

        return (
            <div>
                <Tabs
                    selectedIndex={0}
                >
                    <TabList>
                        {tab}
                    </TabList>
                    {tabPanel}
                </Tabs>
            </div>
        );
    }
}
